import React from 'react';

import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';
import {
  AssignmentFilterTypes,
  AssignmentFilterOptions,
} from 'features/assignment/enums';
import { getSelectedFilterValues } from 'utils/filterUtils';
import { WorkerSearchResponseModel } from 'api/backofficeApiClient';
import { getFullName } from 'utils/personUtils';

type Props = {
  filters: AssignmentFilters;
  onChange: (data: AssignmentFilters) => void;
  workers: WorkerSearchResponseModel[];
  isWorkersLoaded: boolean;
};

export default function WorkerFilter(props: Props) {
  const { filters, onChange, workers, isWorkersLoaded } = props;

  const handleFilterChange =
    (type: AssignmentFilterTypes) => (workers: string[]) => {
      const selectedFilterValues = getSelectedFilterValues(
        workers,
        AssignmentFilterOptions.All,
      );

      onChange({
        ...filters,
        [type]: selectedFilterValues,
      });
    };

  return (
    <SelectWithLoading
      isLoading={!isWorkersLoaded}
      className="full-width"
      value={filters[AssignmentFilterTypes.Worker]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a worker"
      onChange={handleFilterChange(AssignmentFilterTypes.Worker)}
      showSearch
      data-id="workerFilterField"
      filterOption
    >
      {isWorkersLoaded && (
        <>
          <SelectWithLoading.Option value={AssignmentFilterOptions.All}>
            {AssignmentFilterOptions.All}
          </SelectWithLoading.Option>
          {workers.map(({ workerKey, workerFirstName, workerLastName, id }) => (
            <SelectWithLoading.Option
              key={workerKey}
              value={id || ''}
              label={`${workerFirstName} ${workerLastName}`}
            >
              {getFullName(workerFirstName, workerLastName)}
            </SelectWithLoading.Option>
          ))}
        </>
      )}
    </SelectWithLoading>
  );
}
